import { on, select, selectAll, addClass, removeClass, hasClass } from 'modules/dom'

const ACTIVATE_MODAL_CLASS = 'is-active'
const ACTIVATE_BUTTON_CLASS = 'active'
const DEACTIVATE_BUTTON_CLASS = 'hide'

export default function (el) {

    const favoriteButton = select('.js-favorite-check-login', el)
    const pluginButton = select('.simplefavorite-button', el)
    const loginModal = document.querySelector('.modal-login', el)

    if (favoriteButton) {
        on('click', (e) => {
            if(loginModal){
                addClass(ACTIVATE_MODAL_CLASS, loginModal)
            } else {
                return;
            }
        }, favoriteButton)
    }

    if (pluginButton) {
        on('click', (e) => {
            if (!hasClass(ACTIVATE_BUTTON_CLASS, pluginButton)) {
                const postTitle = el.getAttribute('data-title');
                if (postTitle) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        'event': 'favoriteButtonClick',
                        'title': postTitle
                    });
                }
          }
        }, pluginButton);
        if (favoriteButton) {
            addClass(DEACTIVATE_BUTTON_CLASS, pluginButton)
            removeClass(DEACTIVATE_BUTTON_CLASS, favoriteButton)
            if (hasClass(ACTIVATE_BUTTON_CLASS, pluginButton)) {
                addClass(ACTIVATE_BUTTON_CLASS, favoriteButton)
            }
        }
    }
}